var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoValk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 2972.44 2090"
    },
    xmlSpace: "preserve",
    viewBox: "995.51 503 1077.41 1004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1546.04,1180.71c0,0-260.62,61.56-503.8-110.81c0,0-115.94,167.25,17.44,437.1c0,0,207.26-9.23,361.17-92.35   l21.55,22.57l64.64-16.42l20.52,23.6l194.95-53.36v-87.58c0,0,79.01-77.62,57.46-232.55c-21.55-154.94-174.43-155.96-225.73-87.22   l35.91,58.49c0,0,45.15-38.99,107.74-8.21c62.59,30.78,50.28,181.61-1.03,229.84S1577.85,1287.42,1546.04,1180.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1648.93,921.62c11.7,0,23.22,1.39,34.33,4.06l22.85-192.84L1659.42,503l-64.64,218.55l17.42,204.65   C1624.02,923.21,1636.39,921.62,1648.93,921.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1763.05,773.88l-63.1,156.89c15.87,5.93,30.57,14.63,43.34,25.85c5.91,5.19,11.4,10.91,16.45,17.1   l113.1-128.02l24.63-172.38L1763.05,773.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1928.25,832.37L1775.56,997.2c11.3,20.45,18.99,44.43,22.71,71.18c0.43,3.07,0.8,6.1,1.16,9.11l146.26-70.69   l127.23-169.3L1928.25,832.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1950.82,1024.24l-150.28,64.05c2.79,31.01,1.67,58.77-1.7,83.09l111.45-9.87l133.15-92.13L1950.82,1024.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1541.82,1162.73l16.94-3.96l4.99,16.67c17.46,58.57,47.3,93.53,79.82,93.53c13.65,0,27.71-6.43,40.66-18.61   c27.16-25.53,43.45-91.45,35.58-143.96c-4.28-28.58-14.96-48.42-30.06-55.84c-13.41-6.6-26.93-9.94-40.17-9.94   c-27.62,0-46.23,14.66-47.4,15.6l-16.42,14.65l-11.33-19.02l-6.77-11.03c-21.3,23.47-46.83,64.66-43.31,125.13   C1535.48,1164.19,1541.65,1162.77,1541.82,1162.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1123.06,1098.02c54.9,29.06,109.3,47.46,159.87,58.75c15.26-82.25,8.23-169-33.93-199.22   c-61.56-44.12-120.05,15.39-120.05,15.39l24.9,40.02C1133.67,1030.14,1125.86,1066.44,1123.06,1098.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1200.82,922.79c5.65,0,11.22,0.51,16.71,1.48l11.97-164.76l-41.04-163.14l-35.91,170.33l19.15,160.39   C1180.69,924.46,1190.46,922.79,1200.82,922.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1270.55,806.71l-37.3,121.75c9.14,3.28,17.99,7.96,26.51,14.07c5.63,4.03,10.79,8.89,15.49,14.49l71.22-90.8   l9.23-137.49L1270.55,806.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1379.52,856.24l-90.04,122.85c8.2,16.53,13.88,36.72,16.86,60.03l98.62-56.95l74.81-125.93H1379.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1406.98,999.61l-99.63,48.56c1.27,13.33,1.71,27.59,1.28,42.7c-0.23,7.99-0.7,16.07-1.39,24.17l72.28-3.5   l88.3-72.43L1406.98,999.61z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoValk);
export default __webpack_public_path__ + "static/media/RoValk.8e8b02965ffbec3396c2f1ca5d15560c.svg";
export { ForwardRef as ReactComponent };